<template>
    <div>
        <v-app-bar
            app
            flat
        >
            <v-container class="d-flex">
                <router-link :to="{ name: 'home' }">
                    <v-img src="../assets/Colored Logo.png" max-height="50" max-width="50" />
                </router-link>
                <v-spacer />

                <!-- SEARCH BAR FOR VERSION 2.0 -->
                <!-- <v-col
                    cols="8"
                    xs="6" md="4" lg="3"
                    class="ma-0"
                >
                    <v-text-field
                        append-icon="search"
                        align="base"
                        label="Search Handles"
                        hide-details
                    />
                </v-col> -->

                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                            <template v-if="user.userImage">
                                <v-avatar size="48">
                                    <v-img
                                        :src="user.userImage"
                                    />
                                </v-avatar>
                            </template>
                            <template v-else-if="user.email">
                                <v-icon>
                                    account_circle
                                </v-icon>
                            </template>
                            <template v-else>
                                <v-icon>
                                    more_vert
                                </v-icon>
                            </template>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item-group v-if="isLoggedIn">
                            <v-list-item
                                v-if="user && user.handleKey"
                                :to="{
                                    name: 'profile',
                                    params: { handle: user.handleKey }
                                }"
                            >
                                <v-list-item-title>Profile</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="logout()">
                                <v-list-item-title>
                                    Logout
                                </v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                        <v-list-item-group v-else>
                            <v-list-item :to="{ name: 'login' }">
                                <v-list-item-title>
                                    Login
                                </v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-menu>
            </v-container>
        </v-app-bar>
    </div>
</template>

<script>
import UserBus from '../utils/buses/UserBus'
import MessageBus from '../utils/buses/MessageBus'

export default {
    data () {
        return {
            user: {},
            isLoggedIn: false
        }
    },
    mounted () {
        // initialize user
        this.onUpdateUser(UserBus.user)
        UserBus.$on('user-update', this.onUpdateUser)
    },
    methods: {
        logout () {
            const {
                handleKey
            } = this.user

            const currentRoute = this.$route.name

            if (currentRoute === 'profile') {
                // do nothing if current route is profile page
            } else if (handleKey) {
                // if user handle exists, go to their profile
                this.$router.push({ name: 'profile', params: { handle: handleKey } })
            } else {
                // else go to home page
                this.$router.push({ name: 'home' })
            }

            UserBus.logout()
            MessageBus.sendMessage('Successfully Logged Out', 'success')
        },
        onUpdateUser (user) {
            this.user = user
            this.isLoggedIn = user && user.email
        }
    }
}
</script>

<style scoped>

</style>
